import React, { useMemo } from 'react';
import { Skeleton } from '@mui/material';
import { useExtensions } from '../app/ExtensionsContext';
import { EXTENSION_CATALOG } from '../extensions/extensionRegistry';

const catalogDefinesSlot = (slotId) =>
  EXTENSION_CATALOG.some(
    (ext) =>
      Array.isArray(ext.contributions) && ext.contributions.some((c) => c.slotId === slotId)
  );

export function ExtensionSlot({ slotId, context = {} }) {
  const { isEnabled, loading, loadError } = useExtensions();
  const slotInCatalog = useMemo(() => catalogDefinesSlot(slotId), [slotId]);

  if (loading && slotInCatalog && !loadError) {
    return (
      <Skeleton
        variant="rounded"
        width={32}
        height={32}
        animation="wave"
        sx={{ flexShrink: 0 }}
        aria-hidden
      />
    );
  }

  const contributions = EXTENSION_CATALOG
    .filter((ext) => isEnabled(ext.id) && Array.isArray(ext.contributions))
    .flatMap((ext) =>
      ext.contributions
        .filter((c) => c.slotId === slotId)
        .map((c) => ({ ...c, _extensionId: ext.id }))
    )
    .sort((a, b) => (a.priority ?? 100) - (b.priority ?? 100));

  if (contributions.length === 0) return null;

  return (
    <>
      {contributions.map(({ Component, _extensionId, slotId: _sid, priority: _p, ...rest }, idx) => (
        <Component key={`${_extensionId}-${_sid}-${idx}`} {...context} {...rest} />
      ))}
    </>
  );
}
